import { __extends, __assign, __awaiter, __generator, __spreadArray, __rest, __makeTemplateObject } from 'tslib';
import React, { useState, useEffect, useRef, forwardRef } from 'react';
import { useDispatch, useSelector, connect } from 'react-redux';
import { createAxiosInstance } from '@next-common/redux-apollo-helper';
import globalAxios from 'axios';
import { createLogger } from '@next-common/logger';
import { configService } from '@next-common/config-service';
import { useBreakpoint, BreakpointProvider } from '@next-common/breakpoint';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { useGTM } from '@next-common/gtm-provider';
import { styled, useTheme as useTheme$1 } from '@mui/material';
import { colorPalette, Drawer } from '@next-common/mui';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Typography from '@mui/material/Typography';
import Badge from '@mui/material/Badge';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import NotificationAddIcon from '@mui/icons-material/NotificationAdd';
import NotificationAddOutlinedIcon from '@mui/icons-material/NotificationAddOutlined';
import Popover from '@mui/material/Popover';
import Fade from '@mui/material/Fade';
import Snackbar from '@mui/material/Snackbar';
import Link from '@mui/material/Link';
import Portal from '@mui/material/Portal';
import { Blurhash } from 'react-blurhash';
import { useTheme } from '@mui/material/styles';
import Slider from 'react-slick';
import CloseIcon from '@mui/icons-material/Close';
import { ExpandLess } from '@next-common/material-ui-icons';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';
import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';

var ACTIONS;
(function (ACTIONS) {
    ACTIONS["FETCH_GET_GALLERY_ID"] = "productImage/FETCH_GET_GALLERY_ID";
    ACTIONS["FETCH_GALLERY_GET_ID_ERROR"] = "productImage/FETCH_GALLERY_GET_ID_ERROR";
    ACTIONS["FETCH_GALLERY_DATA"] = "productImage/FETCH_GALLERY_DATA";
    ACTIONS["FETCH_PRODUCT_IMAGE_DATA_SUCCESS"] = "productImage/FETCH_PRODUCT_IMAGE_DATA_SUCCESS";
    ACTIONS["FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_SUCCESS"] = "productImage/FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_SUCCESS";
    ACTIONS["FETCH_IS_PRODUCT_NOTE_ENERGETIC_SUCCESS"] = "productImage/FETCH_IS_PRODUCT_NOTE_ENERGETIC_SUCCESS";
    ACTIONS["FETCH_USER_DATA_SUCCESS"] = "productImage/FETCH_USER_DATA_SUCCESS";
    ACTIONS["FETCH_PRODUCT_IMAGE_DATA_ERROR"] = "productImage/FETCH_PRODUCT_IMAGE_DATA_ERROR";
    ACTIONS["FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_ERROR"] = "productImage/FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_ERROR";
    ACTIONS["FETCH_USER_DATA_ERROR"] = "productImage/FETCH_USER_DATA_ERROR";
    ACTIONS["FETCH_IS_PRODUCT_FAVORITE_REQUEST"] = "productImage/FETCH_PRODUCT_IMAGE_DATA_REQUEST";
    ACTIONS["FETCH_IS_PRODUCT_FAVORITE_SUCCESS"] = "productImage/FETCH_IS_PRODUCT_FAVORITE_SUCCESS";
    ACTIONS["FETCH_IS_PRODUCT_FAVORITE_ERROR"] = "productImage/FETCH_IS_PRODUCT_FAVORITE_ERROR";
    ACTIONS["PRODUCT_FAVORITE_UPDATE_REQUEST"] = "productImage/PRODUCT_FAVORITE_UPDATE_REQUEST";
    ACTIONS["PRODUCT_FAVORITE_UPDATE_SUCCESS"] = "productImage/PRODUCT_FAVORITE_UPDATE_SUCCESS";
    ACTIONS["PRODUCT_FAVORITE_UPDATE_ERROR"] = "productImage/PRODUCT_FAVORITE_UPDATE_ERROR";
})(ACTIONS || (ACTIONS = {}));
var ACTIONS$1 = ACTIONS;

/* tslint:disable */
var BASE_PATH = "http://localhost:36200".replace(/\/+$/, "");
/**
 *
 * @export
 * @class BaseAPI
 */
var BaseAPI = /** @class */ (function () {
    function BaseAPI(configuration, basePath, axios) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (axios === void 0) { axios = globalAxios; }
        this.basePath = basePath;
        this.axios = axios;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());
/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
var RequiredError = /** @class */ (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        _this.name = "RequiredError";
        return _this;
    }
    return RequiredError;
}(Error));

/* tslint:disable */
/**
 *
 * @export
 */
var DUMMY_BASE_URL = 'https://example.com';
/**
 *
 * @throws {RequiredError}
 * @export
 */
var assertParamExists = function (functionName, paramName, paramValue) {
    if (paramValue === null || paramValue === undefined) {
        throw new RequiredError(paramName, "Required parameter ".concat(paramName, " was null or undefined when calling ").concat(functionName, "."));
    }
};
function setFlattenedQueryParams(urlSearchParams, parameter, key) {
    if (key === void 0) { key = ""; }
    if (typeof parameter === "object") {
        if (Array.isArray(parameter)) {
            parameter.forEach(function (item) { return setFlattenedQueryParams(urlSearchParams, item, key); });
        }
        else {
            Object.keys(parameter).forEach(function (currentKey) {
                return setFlattenedQueryParams(urlSearchParams, parameter[currentKey], "".concat(key).concat(key !== '' ? '.' : '').concat(currentKey));
            });
        }
    }
    else {
        if (urlSearchParams.has(key)) {
            urlSearchParams.append(key, parameter);
        }
        else {
            urlSearchParams.set(key, parameter);
        }
    }
}
/**
 *
 * @export
 */
var setSearchParams = function (url) {
    var objects = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        objects[_i - 1] = arguments[_i];
    }
    var searchParams = new URLSearchParams(url.search);
    setFlattenedQueryParams(searchParams, objects);
    url.search = searchParams.toString();
};
/**
 *
 * @export
 */
var toPathString = function (url) {
    return url.pathname + url.search + url.hash;
};
/**
 *
 * @export
 */
var createRequestFunction = function (axiosArgs, globalAxios, BASE_PATH, configuration) {
    return function (axios, basePath) {
        if (axios === void 0) { axios = globalAxios; }
        if (basePath === void 0) { basePath = BASE_PATH; }
        var axiosRequestArgs = __assign(__assign({}, axiosArgs.options), { url: ((configuration === null || configuration === void 0 ? void 0 : configuration.basePath) || basePath) + axiosArgs.url });
        return axios.request(axiosRequestArgs);
    };
};

/* tslint:disable */
/**
 * DataForProductImageApi - axios parameter creator
 * @export
 */
var DataForProductImageApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get data for Product Image
         * @param {string} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImageData: function (productId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([productId_1], args_1, true), void 0, function (productId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    assertParamExists('getProductImageData', 'productId', productId);
                    localVarPath = "/restpublic/web/vis/product/hypernova/{productId}/images"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * DataForProductImageApi - functional programming interface
 * @export
 */
var DataForProductImageApiFp = function (configuration) {
    var localVarAxiosParamCreator = DataForProductImageApiAxiosParamCreator(configuration);
    return {
        /**
         * Get data for Product Image
         * @param {string} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductImageData: function (productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductImageData(productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * DataForProductImageApi - object-oriented interface
 * @export
 * @class DataForProductImageApi
 * @extends {BaseAPI}
 */
var DataForProductImageApi = /** @class */ (function (_super) {
    __extends(DataForProductImageApi, _super);
    function DataForProductImageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get data for Product Image
     * @param {string} productId product ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataForProductImageApi
     */
    DataForProductImageApi.prototype.getProductImageData = function (productId, options) {
        var _this = this;
        return DataForProductImageApiFp(this.configuration).getProductImageData(productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DataForProductImageApi;
}(BaseAPI));
/**
 * DataForProductMemoAndPriceAlertInformationApi - axios parameter creator
 * @export
 */
var DataForProductMemoAndPriceAlertInformationApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get data for Product Memo and price alert information
         * @param {string} productId product ID
         * @param {number} userId user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMemoData: function (productId_1, userId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([productId_1, userId_1], args_1, true), void 0, function (productId, userId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    assertParamExists('getProductMemoData', 'productId', productId);
                    // verify required parameter 'userId' is not null or undefined
                    assertParamExists('getProductMemoData', 'userId', userId);
                    localVarPath = "/restpublic/web/vis/product/hypernova/{productId}/memo/{userId}"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)))
                        .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * DataForProductMemoAndPriceAlertInformationApi - functional programming interface
 * @export
 */
var DataForProductMemoAndPriceAlertInformationApiFp = function (configuration) {
    var localVarAxiosParamCreator = DataForProductMemoAndPriceAlertInformationApiAxiosParamCreator(configuration);
    return {
        /**
         * Get data for Product Memo and price alert information
         * @param {string} productId product ID
         * @param {number} userId user ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProductMemoData: function (productId, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getProductMemoData(productId, userId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * DataForProductMemoAndPriceAlertInformationApi - object-oriented interface
 * @export
 * @class DataForProductMemoAndPriceAlertInformationApi
 * @extends {BaseAPI}
 */
var DataForProductMemoAndPriceAlertInformationApi = /** @class */ (function (_super) {
    __extends(DataForProductMemoAndPriceAlertInformationApi, _super);
    function DataForProductMemoAndPriceAlertInformationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get data for Product Memo and price alert information
     * @param {string} productId product ID
     * @param {number} userId user ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataForProductMemoAndPriceAlertInformationApi
     */
    DataForProductMemoAndPriceAlertInformationApi.prototype.getProductMemoData = function (productId, userId, options) {
        var _this = this;
        return DataForProductMemoAndPriceAlertInformationApiFp(this.configuration).getProductMemoData(productId, userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DataForProductMemoAndPriceAlertInformationApi;
}(BaseAPI));
/**
 * DataForProductRepairabilityIndexApi - axios parameter creator
 * @export
 */
var DataForProductRepairabilityIndexApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get Product Repairability Index
         * @param {number} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairabilityIndexData: function (productId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([productId_1], args_1, true), void 0, function (productId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    assertParamExists('getRepairabilityIndexData', 'productId', productId);
                    localVarPath = "/restprivate/products/{productId}/repairability"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * DataForProductRepairabilityIndexApi - functional programming interface
 * @export
 */
var DataForProductRepairabilityIndexApiFp = function (configuration) {
    var localVarAxiosParamCreator = DataForProductRepairabilityIndexApiAxiosParamCreator(configuration);
    return {
        /**
         * Get Product Repairability Index
         * @param {number} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRepairabilityIndexData: function (productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRepairabilityIndexData(productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * DataForProductRepairabilityIndexApi - object-oriented interface
 * @export
 * @class DataForProductRepairabilityIndexApi
 * @extends {BaseAPI}
 */
var DataForProductRepairabilityIndexApi = /** @class */ (function (_super) {
    __extends(DataForProductRepairabilityIndexApi, _super);
    function DataForProductRepairabilityIndexApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get Product Repairability Index
     * @param {number} productId product ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DataForProductRepairabilityIndexApi
     */
    DataForProductRepairabilityIndexApi.prototype.getRepairabilityIndexData = function (productId, options) {
        var _this = this;
        return DataForProductRepairabilityIndexApiFp(this.configuration).getRepairabilityIndexData(productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return DataForProductRepairabilityIndexApi;
}(BaseAPI));
/**
 * EnergeticNoteOfTheProductApi - axios parameter creator
 * @export
 */
var EnergeticNoteOfTheProductApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get energetic note for the Product
         * @param {string} brandName product Brand
         * @param {string} productCode product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergeticNote: function (brandName_1, productCode_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([brandName_1, productCode_1], args_1, true), void 0, function (brandName, productCode, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'brandName' is not null or undefined
                    assertParamExists('getEnergeticNote', 'brandName', brandName);
                    // verify required parameter 'productCode' is not null or undefined
                    assertParamExists('getEnergeticNote', 'productCode', productCode);
                    localVarPath = "/732217ea/logoicons/e1d6742941?mf={brandName}&pn={productCode}&lang=fr&market=FR&format=json"
                        .replace("{".concat("brandName", "}"), encodeURIComponent(String(brandName)))
                        .replace("{".concat("productCode", "}"), encodeURIComponent(String(productCode)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * EnergeticNoteOfTheProductApi - functional programming interface
 * @export
 */
var EnergeticNoteOfTheProductApiFp = function (configuration) {
    var localVarAxiosParamCreator = EnergeticNoteOfTheProductApiAxiosParamCreator(configuration);
    return {
        /**
         * Get energetic note for the Product
         * @param {string} brandName product Brand
         * @param {string} productCode product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergeticNote: function (brandName, productCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEnergeticNote(brandName, productCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * EnergeticNoteOfTheProductApi - object-oriented interface
 * @export
 * @class EnergeticNoteOfTheProductApi
 * @extends {BaseAPI}
 */
/** @class */ ((function (_super) {
    __extends(EnergeticNoteOfTheProductApi, _super);
    function EnergeticNoteOfTheProductApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get energetic note for the Product
     * @param {string} brandName product Brand
     * @param {string} productCode product code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EnergeticNoteOfTheProductApi
     */
    EnergeticNoteOfTheProductApi.prototype.getEnergeticNote = function (brandName, productCode, options) {
        var _this = this;
        return EnergeticNoteOfTheProductApiFp(this.configuration).getEnergeticNote(brandName, productCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EnergeticNoteOfTheProductApi;
})(BaseAPI));
/**
 * GetEnergeticNoteImageApi - axios parameter creator
 * @export
 */
var GetEnergeticNoteImageApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get Energetic Note Image
         * @param {string} brandName product Brand
         * @param {string} productCode product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergeticNoteImage: function (brandName_1, productCode_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([brandName_1, productCode_1], args_1, true), void 0, function (brandName, productCode, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'brandName' is not null or undefined
                    assertParamExists('getEnergeticNoteImage', 'brandName', brandName);
                    // verify required parameter 'productCode' is not null or undefined
                    assertParamExists('getEnergeticNoteImage', 'productCode', productCode);
                    localVarPath = "/732217ea/page/e1d6742941/LLogoService?logoid=11&mf={brandName}&pn={productCode}&style=Standard&lang=fr&market=FR"
                        .replace("{".concat("brandName", "}"), encodeURIComponent(String(brandName)))
                        .replace("{".concat("productCode", "}"), encodeURIComponent(String(productCode)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * GetEnergeticNoteImageApi - functional programming interface
 * @export
 */
var GetEnergeticNoteImageApiFp = function (configuration) {
    var localVarAxiosParamCreator = GetEnergeticNoteImageApiAxiosParamCreator(configuration);
    return {
        /**
         * Get Energetic Note Image
         * @param {string} brandName product Brand
         * @param {string} productCode product code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEnergeticNoteImage: function (brandName, productCode, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getEnergeticNoteImage(brandName, productCode, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * GetEnergeticNoteImageApi - object-oriented interface
 * @export
 * @class GetEnergeticNoteImageApi
 * @extends {BaseAPI}
 */
/** @class */ ((function (_super) {
    __extends(GetEnergeticNoteImageApi, _super);
    function GetEnergeticNoteImageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get Energetic Note Image
     * @param {string} brandName product Brand
     * @param {string} productCode product code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetEnergeticNoteImageApi
     */
    GetEnergeticNoteImageApi.prototype.getEnergeticNoteImage = function (brandName, productCode, options) {
        var _this = this;
        return GetEnergeticNoteImageApiFp(this.configuration).getEnergeticNoteImage(brandName, productCode, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GetEnergeticNoteImageApi;
})(BaseAPI));
/**
 * GetGalleryDataByIDApi - axios parameter creator
 * @export
 */
var GetGalleryDataByIDApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get Gallery data by ID
         * @param {string} galleryId gallery ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGalleryData: function (galleryId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([galleryId_1], args_1, true), void 0, function (galleryId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'galleryId' is not null or undefined
                    assertParamExists('getGalleryData', 'galleryId', galleryId);
                    localVarPath = "/restprivate/v2/galleries/{galleryId}"
                        .replace("{".concat("galleryId", "}"), encodeURIComponent(String(galleryId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * GetGalleryDataByIDApi - functional programming interface
 * @export
 */
var GetGalleryDataByIDApiFp = function (configuration) {
    var localVarAxiosParamCreator = GetGalleryDataByIDApiAxiosParamCreator(configuration);
    return {
        /**
         * Get Gallery data by ID
         * @param {string} galleryId gallery ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGalleryData: function (galleryId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getGalleryData(galleryId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * GetGalleryDataByIDApi - factory interface
 * @export
 */
var GetGalleryDataByIDApiFactory = function (configuration, basePath, axios) {
    var localVarFp = GetGalleryDataByIDApiFp(configuration);
    return {
        /**
         * Get Gallery data by ID
         * @param {string} galleryId gallery ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGalleryData: function (galleryId, options) {
            return localVarFp.getGalleryData(galleryId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * GetGalleryDataByIDApi - object-oriented interface
 * @export
 * @class GetGalleryDataByIDApi
 * @extends {BaseAPI}
 */
/** @class */ ((function (_super) {
    __extends(GetGalleryDataByIDApi, _super);
    function GetGalleryDataByIDApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get Gallery data by ID
     * @param {string} galleryId gallery ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetGalleryDataByIDApi
     */
    GetGalleryDataByIDApi.prototype.getGalleryData = function (galleryId, options) {
        var _this = this;
        return GetGalleryDataByIDApiFp(this.configuration).getGalleryData(galleryId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GetGalleryDataByIDApi;
})(BaseAPI));
/**
 * GetGalleryIDByProductIDApi - axios parameter creator
 * @export
 */
var GetGalleryIDByProductIDApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get Gallery ID by product ID
         * @param {string} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGalleryId: function (productId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([productId_1], args_1, true), void 0, function (productId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'productId' is not null or undefined
                    assertParamExists('getGalleryId', 'productId', productId);
                    localVarPath = "/restpublic/web/vis/products/{productId}"
                        .replace("{".concat("productId", "}"), encodeURIComponent(String(productId)));
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * GetGalleryIDByProductIDApi - functional programming interface
 * @export
 */
var GetGalleryIDByProductIDApiFp = function (configuration) {
    var localVarAxiosParamCreator = GetGalleryIDByProductIDApiAxiosParamCreator(configuration);
    return {
        /**
         * Get Gallery ID by product ID
         * @param {string} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGalleryId: function (productId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getGalleryId(productId, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * GetGalleryIDByProductIDApi - factory interface
 * @export
 */
var GetGalleryIDByProductIDApiFactory = function (configuration, basePath, axios) {
    var localVarFp = GetGalleryIDByProductIDApiFp(configuration);
    return {
        /**
         * Get Gallery ID by product ID
         * @param {string} productId product ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getGalleryId: function (productId, options) {
            return localVarFp.getGalleryId(productId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
/**
 * GetGalleryIDByProductIDApi - object-oriented interface
 * @export
 * @class GetGalleryIDByProductIDApi
 * @extends {BaseAPI}
 */
/** @class */ ((function (_super) {
    __extends(GetGalleryIDByProductIDApi, _super);
    function GetGalleryIDByProductIDApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get Gallery ID by product ID
     * @param {string} productId product ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof GetGalleryIDByProductIDApi
     */
    GetGalleryIDByProductIDApi.prototype.getGalleryId = function (productId, options) {
        var _this = this;
        return GetGalleryIDByProductIDApiFp(this.configuration).getGalleryId(productId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return GetGalleryIDByProductIDApi;
})(BaseAPI));
/**
 * UpdateProductMemoApi - axios parameter creator
 * @export
 */
var UpdateProductMemoApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Update a memo with the specified product ID
         * @param {number} xAjaxrequest
         * @param {string} [action]
         * @param {string} [productId]
         * @param {string} [skipkmadding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productMemoUpdate: function (xAjaxrequest_1, action_1, productId_1, skipkmadding_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([xAjaxrequest_1, action_1, productId_1, skipkmadding_1], args_1, true), void 0, function (xAjaxrequest, action, productId, skipkmadding, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, localVarFormParams, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'xAjaxrequest' is not null or undefined
                    assertParamExists('productMemoUpdate', 'xAjaxrequest', xAjaxrequest);
                    localVarPath = "/memo";
                    localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarFormParams = new URLSearchParams();
                    if (xAjaxrequest != null) {
                        localVarHeaderParameter['x-ajaxrequest'] = typeof xAjaxrequest === 'string'
                            ? xAjaxrequest
                            : JSON.stringify(xAjaxrequest);
                    }
                    if (action !== undefined) {
                        localVarFormParams.set('action', action);
                    }
                    if (productId !== undefined) {
                        localVarFormParams.set('productId', productId);
                    }
                    if (skipkmadding !== undefined) {
                        localVarFormParams.set('skipkmadding', skipkmadding);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
                    setSearchParams(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = localVarFormParams.toString();
                    return [2 /*return*/, {
                            url: toPathString(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
/**
 * UpdateProductMemoApi - functional programming interface
 * @export
 */
var UpdateProductMemoApiFp = function (configuration) {
    var localVarAxiosParamCreator = UpdateProductMemoApiAxiosParamCreator(configuration);
    return {
        /**
         * Update a memo with the specified product ID
         * @param {number} xAjaxrequest
         * @param {string} [action]
         * @param {string} [productId]
         * @param {string} [skipkmadding]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        productMemoUpdate: function (xAjaxrequest, action, productId, skipkmadding, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.productMemoUpdate(xAjaxrequest, action, productId, skipkmadding, options)];
                        case 1:
                            localVarAxiosArgs = _a.sent();
                            return [2 /*return*/, createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)];
                    }
                });
            });
        },
    };
};
/**
 * UpdateProductMemoApi - object-oriented interface
 * @export
 * @class UpdateProductMemoApi
 * @extends {BaseAPI}
 */
var UpdateProductMemoApi = /** @class */ (function (_super) {
    __extends(UpdateProductMemoApi, _super);
    function UpdateProductMemoApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Update a memo with the specified product ID
     * @param {number} xAjaxrequest
     * @param {string} [action]
     * @param {string} [productId]
     * @param {string} [skipkmadding]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UpdateProductMemoApi
     */
    UpdateProductMemoApi.prototype.productMemoUpdate = function (xAjaxrequest, action, productId, skipkmadding, options) {
        var _this = this;
        return UpdateProductMemoApiFp(this.configuration).productMemoUpdate(xAjaxrequest, action, productId, skipkmadding, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UpdateProductMemoApi;
}(BaseAPI));

var logger = createLogger('product-image');
var loadGalleryData = function (axiosInstance, productId, basePath, galleryIdUrl, galleryDataGatewayUrl) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var getGalleryIdResult, galleryData, dataForProductImageApi, err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 5, , 6]);
                    return [4 /*yield*/, GetGalleryIDByProductIDApiFactory(undefined, galleryIdUrl, axiosInstance).getGalleryId(productId)];
                case 1:
                    getGalleryIdResult = (_a.sent()).data;
                    if (!getGalleryIdResult.galleryId) return [3 /*break*/, 3];
                    return [4 /*yield*/, GetGalleryDataByIDApiFactory(undefined, galleryDataGatewayUrl, axiosInstance).getGalleryData(getGalleryIdResult.galleryId)];
                case 2:
                    galleryData = (_a.sent()).data;
                    dispatch({
                        type: ACTIONS$1.FETCH_GET_GALLERY_ID,
                        payload: {
                            galleryIdResponse: __assign({}, getGalleryIdResult),
                        },
                    });
                    dispatch({
                        type: ACTIONS$1.FETCH_GALLERY_DATA,
                        payload: {
                            galleryData: galleryData,
                        },
                    });
                    return [3 /*break*/, 4];
                case 3:
                    dataForProductImageApi = new DataForProductImageApi(undefined, basePath, axiosInstance);
                    return [2 /*return*/, dataForProductImageApi
                            .getProductImageData(productId)
                            .then(function (result) {
                            var data = result.data;
                            // @ts-expect-error productId
                            data.productId = productId;
                            dispatch({
                                type: ACTIONS$1.FETCH_PRODUCT_IMAGE_DATA_SUCCESS,
                                payload: data,
                            });
                        })
                            .catch(function (err) {
                            var _a;
                            if (err instanceof Error) {
                                logger.error("".concat(err.name, ": ").concat(err.message), { exception: err.stack });
                            }
                            else {
                                logger.error('An error occurred while loading product images', { exception: err });
                            }
                            dispatch({
                                type: ACTIONS$1.FETCH_PRODUCT_IMAGE_DATA_ERROR,
                                payload: { statusCode: (_a = err.response) === null || _a === void 0 ? void 0 : _a.status },
                            });
                        })];
                case 4: return [2 /*return*/];
                case 5:
                    err_1 = _a.sent();
                    if (err_1 instanceof Error) {
                        logger.error("".concat(err_1.name, ": ").concat(err_1.message), { exception: err_1.stack });
                    }
                    else {
                        logger.error('An error occurred while receiting gallery ID by product ID', { exception: err_1 });
                    }
                    return [3 /*break*/, 6];
                case 6: return [2 /*return*/];
            }
        });
    }); };
};
var loadProductImagesData = function (axiosInstance, productId, basePath) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var dataForProductImageApi;
        return __generator(this, function (_a) {
            dataForProductImageApi = new DataForProductImageApi(undefined, basePath, axiosInstance);
            return [2 /*return*/, dataForProductImageApi
                    .getProductImageData(productId)
                    .then(function (result) {
                    var data = result.data;
                    var payload = {
                        blurredMemoUpdateActionUrl: data.blurredMemoUpdateActionUrl,
                        urlProductAlert: data.urlProductAlert
                    };
                    dispatch({
                        type: ACTIONS$1.FETCH_PRODUCT_IMAGE_DATA_SUCCESS,
                        payload: payload,
                    });
                })
                    .catch(function (err) {
                    var _a;
                    if (err instanceof Error) {
                        logger.error("".concat(err.name, ": ").concat(err.message), { exception: err.stack });
                    }
                    else {
                        logger.error('An error occurred while loading product images', { exception: err });
                    }
                    dispatch({
                        type: ACTIONS$1.FETCH_PRODUCT_IMAGE_DATA_ERROR,
                        payload: { statusCode: (_a = err.response) === null || _a === void 0 ? void 0 : _a.status },
                    });
                })];
        });
    }); };
};
var loadRepairabilityIndexData = function (axiosInstance, productId, repairabilityIndexBaseUrl, repairabilityIndexSvgLocationBaseUrl) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var intProductId, dataForProductRepairabilityIndexApi;
        return __generator(this, function (_a) {
            intProductId = Number(productId);
            dataForProductRepairabilityIndexApi = new DataForProductRepairabilityIndexApi(undefined, repairabilityIndexBaseUrl, axiosInstance);
            return [2 /*return*/, dataForProductRepairabilityIndexApi
                    .getRepairabilityIndexData(intProductId)
                    .then(function (result) {
                    var data = result.data;
                    var repairabilityIndexPdfUrl = data.document;
                    var repairabilityIndexImgUrl = '';
                    if (data.index !== undefined && data.index !== null) {
                        var wholePart = Math.floor(data.index);
                        var decimalPart = Math.floor((data.index * 10) % 10);
                        repairabilityIndexImgUrl = "".concat(repairabilityIndexSvgLocationBaseUrl).concat(wholePart, "_").concat(decimalPart, ".svg");
                    }
                    var details = {
                        repairabilityIndexImageUrl: repairabilityIndexImgUrl,
                        repairabilityIndexPdfUrl: repairabilityIndexPdfUrl || '',
                    };
                    dispatch({
                        type: ACTIONS$1.FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_SUCCESS,
                        payload: details,
                    });
                })
                    .catch(function (err) {
                    if (err instanceof Error) {
                        logger.debug("".concat(err.name, ": ").concat(err.message), { exception: err.stack });
                    }
                    else {
                        logger.debug('An error occurred while loading repairability index', { exception: err });
                    }
                })];
        });
    }); };
};

var actions = /*#__PURE__*/Object.freeze({
  __proto__: null,
  loadGalleryData: loadGalleryData,
  loadProductImagesData: loadProductImagesData,
  loadRepairabilityIndexData: loadRepairabilityIndexData
});

var initialAction = function (watchContext, baseUrl, preloadedConfig) {
    // TODO: dispatch type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var promises, axiosInstance, _a, productId, wsBaseUrl, galleryDataGatewayUrl, galleryIdBaseUrl, axiosRepairabilityIndex, config;
        return __generator(this, function (_b) {
            promises = [];
            axiosInstance = createAxiosInstance({ context: watchContext, moduleName: 'ProductImageModule' });
            _a = preloadedConfig.ProductImage, productId = _a.productId, wsBaseUrl = _a.wsBaseUrl, galleryDataGatewayUrl = _a.galleryDataGatewayUrl, galleryIdBaseUrl = _a.galleryIdBaseUrl;
            // load Data when called on nextJs Eshop Landing Desktop & mob + and on pricemobile or monolithe
            if (productId) {
                promises.push(dispatch(loadProductImagesData(axiosInstance, productId, wsBaseUrl)));
                promises.push(dispatch(loadGalleryData(axiosInstance, productId, wsBaseUrl, galleryIdBaseUrl, galleryDataGatewayUrl)));
            }
            axiosRepairabilityIndex = createAxiosInstance({
                context: watchContext,
                moduleName: 'ProductImageRepairabilityIndexModule',
                log404AsDebug: true,
            });
            config = configService.get();
            promises.push(dispatch(loadRepairabilityIndexData(axiosRepairabilityIndex, preloadedConfig.ProductImage.productId, config.repairabilityIndex.repairabilityIndexPdfUrl, config.repairabilityIndex.repairabilityIndexSvgLocationPrefix)));
            return [2 /*return*/, Promise.all(promises)];
        });
    }); };
};

var previewStyles = {
    miniPreviewWrapper: function (selected) { return ({
        border: "1px solid ".concat(selected ? 'black' : colorPalette.gray300),
        cursor: 'pointer',
        width: '48px',
        height: '48px',
        borderRadius: '8px',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': {
            boxShadow: "0px 0px 0px 4px ".concat(colorPalette.gray100),
        },
    }); },
    popupPreviewWrapper: function (selected) { return ({
        border: "1px solid ".concat(selected ? 'black' : colorPalette.gray300),
        cursor: 'pointer',
        width: '56px',
        height: '56px',
        borderRadius: '8px',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': {
            boxShadow: "0px 0px 0px 4px ".concat(colorPalette.gray100),
        },
    }); },
    miniPreview: {
        width: '32px',
        height: '32px',
        objectFit: 'contain',
        borderRadius: '8px',
    },
    seeMoreWrapper: {
        position: 'relative',
        display: 'flex',
        height: '48px',
        width: '48px',
        cursor: 'pointer',
        justifyContent: 'center',
        alignItems: 'center',
        border: "1px solid ".concat(colorPalette.gray300),
        borderRadius: '8px',
        '&:hover': {
            boxShadow: "0px 0px 0px 4px ".concat(colorPalette.gray100),
        },
    },
    seeMoreContainer: {
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,
        borderRadius: '6px',
        opacity: 0.5,
        backgroundColor: 'white',
    },
};
var PreviewCover = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme, previewLength = _a.previewLength;
    return (_b = {
            position: 'absolute',
            width: '100%',
            height: '100%',
            top: 0,
            left: 0,
            borderRadius: '6px',
            backgroundColor: 'white'
        },
        _b[theme.breakpoints.up('lg')] = {
            opacity: previewLength - 1 === 0 ? 0 : 0.5,
        },
        _b);
});
var MiniPreviewList = styled(Stack)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.down('sm')] = {
            '&& :nth-of-type(5)': {
                display: 'none',
            },
        },
        _b);
});

var getSizeOptimizedImageUrl = function (imageUrl, width, height) {
    return "".concat(imageUrl, "?frz-width=").concat(width).concat(height ? "&frz-height=".concat(height) : '', "&frz-fit=contain");
};
var handleImageSource = function (source, index, size, isBlurHash) {
    if (isBlurHash === void 0) { isBlurHash = false; }
    if (!source || !Array.isArray(source) || index < 0 || index >= source.length) {
        throw new Error('Invalid source type, index out of bounds, or source is undefined');
    }
    var image = source[index];
    if (isBlurHash) {
        return typeof image === 'object' && (image === null || image === void 0 ? void 0 : image.blurHash) ? image.blurHash : '';
    }
    if (typeof image === 'string') {
        return getSizeOptimizedImageUrl(image, size);
    }
    if (typeof image === 'object' && image.url) {
        return getSizeOptimizedImageUrl(image.url, size);
    }
    throw new Error('Invalid item type in source array');
};
var hypernovaClassWrapper = function () {
    var id = 'hpernova-class-wrapper';
    var hpernovaClassWrapper = document.getElementById(id);
    if (hpernovaClassWrapper) {
        return hpernovaClassWrapper;
    }
    var elemDiv = document.createElement('div');
    elemDiv.classList.add('_hy');
    elemDiv.id = id;
    document.body.appendChild(elemDiv);
    return elemDiv;
};

var Preview = function (_a) {
    var images = _a.images, onImageClick = _a.onImageClick, onVideoClick = _a.onVideoClick, _b = _a.video, video = _b === void 0 ? false : _b, hoveredImageIndex = _a.hoveredImageIndex, setHoveredImageIndex = _a.setHoveredImageIndex;
    var _c = useState(4), previewLength = _c[0], setPreviewLenght = _c[1];
    var breakpoint = useBreakpoint().breakpoint;
    useEffect(function () {
        var updatePreviewLenght = function () {
            var width = window.innerWidth;
            if (width < 1440) {
                setPreviewLenght(4);
            }
            else {
                setPreviewLenght(5);
            }
        };
        updatePreviewLenght();
        window.addEventListener('resize', updatePreviewLenght);
        return function () {
            window.removeEventListener('resize', updatePreviewLenght);
        };
    }, []);
    if (breakpoint === 'phone' || !images) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement(MiniPreviewList, { spacing: 1, "data-qa": "image-mini-preview-list", sx: {
            marginRight: '8px',
        } },
        Array.isArray(images) &&
            images.slice(0, previewLength).map(function (src, i) {
                var imageSrc = typeof src === 'string' ? src : src.url || '';
                return (React.createElement(Stack, { component: "div", key: i, sx: previewStyles.miniPreviewWrapper(i === hoveredImageIndex), onClick: onImageClick, onMouseEnter: function () {
                        setHoveredImageIndex(i);
                    } },
                    React.createElement(Box, { sx: previewStyles.miniPreview, component: "img", src: getSizeOptimizedImageUrl(imageSrc, 48, 48), alt: "small" })));
            }),
        Array.isArray(images) && images.length > previewLength && (React.createElement(Box, { component: "div", sx: previewStyles.seeMoreWrapper },
            React.createElement(PreviewCover, { component: "div", sx: previewStyles.seeMoreContainer, previewLength: images.length - previewLength }),
            React.createElement(Stack, { component: "div", sx: {
                    position: 'absolute',
                    width: '90%',
                    height: '90%',
                }, alignItems: 'center', justifyContent: 'center', onClick: function () {
                    setHoveredImageIndex(previewLength);
                    if (onImageClick) {
                        onImageClick();
                    }
                } },
                React.createElement(Badge, { badgeContent: "+".concat(images.length - previewLength) })),
            React.createElement(Box, { component: "img", src: handleImageSource(images, images.length - previewLength, 32), alt: 'small image', sx: previewStyles.miniPreview }))),
        video && (React.createElement(Box, { "data-qa": "test-video", component: "div", sx: previewStyles.seeMoreWrapper },
            React.createElement(Stack, { component: "div", sx: previewStyles.miniPreview, alignItems: 'center', justifyContent: 'center', onClick: onVideoClick },
                React.createElement(PlayArrowIcon, { sx: {
                        fontSize: '20px',
                    } }),
                React.createElement(Typography, { fontWeight: 600, fontSize: "12px" }, "Vid\u00E9o"))))));
};

var favoriteStyles = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: "1px solid ".concat(colorPalette.gray300),
    backgroundColor: 'white',
    cursor: 'pointer',
    borderRadius: 100,
    width: 48,
    height: 48,
};

var Favorite = function (_a) {
    var isFavorite = _a.isFavorite, onFavoriteClick = _a.onFavoriteClick;
    var ref = useRef(null);
    useEffect(function () {
        var currentRef = ref.current;
        var handleHover = function () {
            if (!currentRef)
                return;
            currentRef.style.backgroundColor = colorPalette.gray200;
        };
        var handleLeave = function () {
            if (!currentRef)
                return;
            currentRef.style.backgroundColor = 'white';
        };
        currentRef === null || currentRef === void 0 ? void 0 : currentRef.addEventListener('mouseover', handleHover);
        currentRef === null || currentRef === void 0 ? void 0 : currentRef.addEventListener('mouseleave', handleLeave);
        return function () {
            currentRef === null || currentRef === void 0 ? void 0 : currentRef.removeEventListener('mouseover', handleHover);
            currentRef === null || currentRef === void 0 ? void 0 : currentRef.removeEventListener('mouseleave', handleLeave);
        };
    }, []);
    return (React.createElement(Box, { component: "div", ref: ref, "data-qa": "Favorite-test", className: "frznocache", sx: favoriteStyles, onClick: onFavoriteClick }, isFavorite ? (React.createElement(FavoriteIcon, { sx: { fontSize: 24, color: colorPalette.red800 } })) : (React.createElement(FavoriteBorderIcon, { sx: { fontSize: 24, color: colorPalette.gray700 } }))));
};

var _a$2;
var notificationStyles = {
    buttonWrapper: (_a$2 = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            border: "1px solid ".concat(colorPalette.gray300),
            backgroundColor: 'white',
            cursor: 'pointer',
            borderRadius: 100,
            width: 48,
            height: 48
        },
        _a$2[':hover'] = {
            backgroundColor: colorPalette.gray200,
        },
        _a$2),
};

var Notification = function (_a) {
    var isNotificationOn = _a.isNotificationOn, _b = _a.dataQa, dataQa = _b === void 0 ? 'notification-comp' : _b, onNotificationClick = _a.onNotificationClick;
    var ref = useRef(null);
    useEffect(function () {
        var currentRef = ref.current;
        var handleHover = function () {
            if (!currentRef)
                return;
            currentRef.style.backgroundColor = colorPalette.gray200;
        };
        var handleLeave = function () {
            if (!currentRef)
                return;
            currentRef.style.backgroundColor = 'white';
        };
        currentRef === null || currentRef === void 0 ? void 0 : currentRef.addEventListener('mouseover', handleHover);
        currentRef === null || currentRef === void 0 ? void 0 : currentRef.addEventListener('mouseleave', handleLeave);
        return function () {
            currentRef === null || currentRef === void 0 ? void 0 : currentRef.removeEventListener('mouseover', handleHover);
            currentRef === null || currentRef === void 0 ? void 0 : currentRef.removeEventListener('mouseleave', handleLeave);
        };
    }, []);
    return (React.createElement(Box, { component: "div", ref: ref, "data-qa": dataQa, className: "frznocache", sx: notificationStyles.buttonWrapper, onClick: onNotificationClick }, isNotificationOn ? (React.createElement(NotificationAddIcon, { sx: { fontSize: 24, color: colorPalette.red800 } })) : (React.createElement(NotificationAddOutlinedIcon, { sx: { fontSize: 24, color: colorPalette.gray700 } }))));
};

var RepairabilityIndex = function (_a) {
    var imageUrl = _a.imageUrl, pdfUrl = _a.pdfUrl;
    var boxStyles = {
        backgroundColor: colorPalette.white,
        border: "".concat(colorPalette.gray200, " solid 1px"),
        borderRadius: '8px',
        padding: '8.5px 7px',
        display: 'flex',
        width: 'fit-content',
    };
    return (React.createElement(Box, { "data-qa": "repairability-test", component: "a", href: pdfUrl || undefined, target: "_blank", sx: boxStyles },
        React.createElement(Box, { component: "img", src: imageUrl, sx: {
                width: '40px',
                height: '27px',
            }, alt: "Repairability Index" })));
};

var _a$1;
var imageBoxStyle = function (theme, withSideBanner) {
    var _a;
    return _a = {
            objectFit: 'contain',
            objectPosition: 'center',
            width: '532px',
            height: '532px'
        },
        _a[theme.breakpoints.down('xl')] = {
            height: withSideBanner ? '400px' : '472px',
            width: withSideBanner ? '400px' : '472px',
        },
        _a[theme.breakpoints.down('llg')] = {
            height: '270px',
            width: '270px',
        },
        _a[theme.breakpoints.down('sm')] = {
            width: '375px',
            height: '270px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        _a;
};
var mobileImageBoxStyle = (_a$1 = {},
    _a$1['.slick-dots'] = {
        'li.slick-active button:before': {
            color: colorPalette.red800,
            fontSize: '6px',
        },
        li: {
            width: '6px',
            height: '20px',
        },
    },
    _a$1['.slick-slide'] = {
        img: {
            width: '290px',
            height: '290px',
            objectFit: 'contain',
        },
    },
    _a$1);
var imageBoxWrapperStyle = {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'zoom-in',
};
var imageIconsWrapperStyle = {
    position: 'absolute',
    right: 12,
    top: 0,
    alignItems: 'center',
    gap: '8px',
};
var ProductImageWrapper = function (theme, withSideBanner) {
    var _a;
    return (_a = {
            width: '588px',
            height: '532px'
        },
        _a[theme.breakpoints.down('xl')] = {
            width: withSideBanner ? '456px' : '528px',
            height: withSideBanner ? '400px' : '472px',
        },
        _a[theme.breakpoints.down('llg')] = {
            width: '270px',
            height: '270px',
        },
        _a[theme.breakpoints.down('sm')] = {
            width: '375px',
            marginTop: '16px',
            height: '372px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        _a);
};
var imageContainerDimStyle = function (theme, withSideBanner) {
    var _a;
    return (_a = {
            height: '532px',
            justifyContent: 'center'
        },
        _a[theme.breakpoints.down('xl')] = {
            maxHeight: withSideBanner ? '400px' : '472px',
        },
        _a[theme.breakpoints.down('hd')] = {
            width: '400px',
        },
        _a[theme.breakpoints.down('llg')] = {
            maxHeight: '270px',
        },
        _a);
};
var zoomSquareStyle = function (theme) {
    var _a;
    return (_a = {
            position: 'absolute',
            display: 'none',
            width: '190px',
            height: '190px'
        },
        _a[theme.breakpoints.down('llg')] = {
            width: '140px',
            height: '140px',
        },
        _a.backgroundColor = colorPalette.white,
        _a.opacity = 0.4,
        _a.pointerEvents = 'none',
        _a.borderRadius = '8px',
        _a.border = "1px solid ".concat(colorPalette.white),
        _a);
};
var zoomOverViewStyle = {
    position: 'absolute',
    height: '560px',
    width: '560px',
    overflow: 'hidden',
    borderRadius: '8px',
    border: "4px solid ".concat(colorPalette.white),
    boxShadow: '0px 16px 24px 2px rgba(0, 0, 0, 0.14), 0px 6px 30px 5px rgba(0, 0, 0, 0.12)',
    zIndex: 9999,
    backgroundColor: "".concat(colorPalette.white),
};

var getFavoriteState = function (productId, userId) {
    // TODO: dispatch type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (dispatch) {
        dispatch({ type: ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_REQUEST });
        if (!userId)
            return;
        var gatewayUrl = '';
        var dataForProductMemoApi = new DataForProductMemoAndPriceAlertInformationApi(undefined, gatewayUrl);
        dataForProductMemoApi
            .getProductMemoData(productId, userId)
            .then(function (result) {
            var data = result.data;
            dispatch({
                type: ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_SUCCESS,
                payload: data,
            });
        })
            .catch(function (err) {
            dispatch({
                type: ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_ERROR,
                payload: err.response && err.response.data,
            });
        });
    };
};
var handleMemoClick = function (isFavorite, url) {
    // TODO: dispatch type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (dispatch) {
        dispatch({ type: ACTIONS$1.PRODUCT_FAVORITE_UPDATE_REQUEST });
        var res = url.split('?');
        var body = res[1] + '&skipkmadding=' + !isFavorite;
        var params = {};
        body.split('&').forEach(function (param) {
            var _a = param.split('='), key = _a[0], value = _a[1];
            params[key] = value;
        });
        new UpdateProductMemoApi(undefined, '')
            .productMemoUpdate(1, params['action'], params['productId'], params['skipkmadding'])
            .then(function (result) {
            var _a, _b;
            var data = result.data;
            switch (data.code) {
                case 1:
                    if ((_a = data === null || data === void 0 ? void 0 : data.values) === null || _a === void 0 ? void 0 : _a.loginURL)
                        window.location.href = ((_b = data === null || data === void 0 ? void 0 : data.values) === null || _b === void 0 ? void 0 : _b.loginURL) + '&ajx_param=memo&ajx_value=submit';
                    break;
                case 2:
                    dispatch({
                        type: ACTIONS$1.PRODUCT_FAVORITE_UPDATE_SUCCESS,
                        payload: true,
                    });
                    break;
                case 3:
                    dispatch({
                        type: ACTIONS$1.PRODUCT_FAVORITE_UPDATE_SUCCESS,
                        payload: false,
                    });
                    break;
                default:
                    dispatch({
                        type: ACTIONS$1.PRODUCT_FAVORITE_UPDATE_ERROR,
                        payload: false,
                    });
                    break;
            }
        })
            .catch(function (err) {
            dispatch({
                type: ACTIONS$1.PRODUCT_FAVORITE_UPDATE_ERROR,
                payload: err.response && err.response.data,
            });
        });
    };
};
var getNoteEnergetic = function (summaryAttributeValue, setEnergeticNoteIcon, setEnergeticNoteImage) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, _b, brandName, _c, productCode, gatewayUrl, response, result, icon, imageUrl, imageNote, resultImageNote, err_1;
    var _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    return __generator(this, function (_q) {
        switch (_q.label) {
            case 0:
                _q.trys.push([0, 5, , 6]);
                _a = summaryAttributeValue.split(','), _b = _a[0], brandName = _b === void 0 ? '' : _b, _c = _a[1], productCode = _c === void 0 ? '' : _c;
                gatewayUrl = 'https://ws.cs.1worldsync.com';
                return [4 /*yield*/, fetch("".concat(gatewayUrl, "/732217ea/logoicons/e1d6742941?mf=").concat(brandName, "&pn=").concat(productCode, "&lang=fr&market=FR&format=json"), {
                        method: 'GET',
                    })];
            case 1:
                response = _q.sent();
                return [4 /*yield*/, response.json()];
            case 2:
                result = _q.sent();
                icon = (_k = (_j = (_h = (_g = (_f = (_e = (_d = result === null || result === void 0 ? void 0 : result.product_data_response) === null || _d === void 0 ? void 0 : _d.contentResponse) === null || _e === void 0 ? void 0 : _e.logos[0]) === null || _f === void 0 ? void 0 : _f.logo) === null || _g === void 0 ? void 0 : _g.media) === null || _h === void 0 ? void 0 : _h.images[0]) === null || _j === void 0 ? void 0 : _j.image) === null || _k === void 0 ? void 0 : _k.url;
                imageUrl = (_p = (_o = (_m = (_l = result === null || result === void 0 ? void 0 : result.product_data_response) === null || _l === void 0 ? void 0 : _l.contentResponse) === null || _m === void 0 ? void 0 : _m.logos[0]) === null || _o === void 0 ? void 0 : _o.logo) === null || _p === void 0 ? void 0 : _p.contentUrl;
                return [4 /*yield*/, fetch("".concat(gatewayUrl, "/732217ea/page/e1d6742941/LLogoService?logoid=11&mf=").concat(brandName, "&pn=").concat(productCode, "&style=Standard&lang=fr&market=FR"), {
                        method: 'GET',
                    })];
            case 3:
                imageNote = _q.sent();
                return [4 /*yield*/, imageNote.text()];
            case 4:
                resultImageNote = _q.sent();
                setEnergeticNoteIcon(icon);
                return [2 /*return*/, imageUrl && setEnergeticNoteImage(resultImageNote)];
            case 5:
                err_1 = _q.sent();
                console.log('err', err_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };

var NoProductImage = function (_a) {
    var height = _a.height, width = _a.width;
    return (React.createElement(Stack, { justifyContent: "center", alignItems: "center", sx: {
            width: width || '100%',
            height: height || '100%',
        } },
        React.createElement(Box, { component: "img", src: getSizeOptimizedImageUrl('https://fr.shopping.rakuten.com/visuels/0_next-common/product-image/image_disabled.png', 532), sx: {
                objectFit: 'contain',
            }, alt: "No product image" })));
};

var energeticNoteStyles = {
    indexWrapper: {
        backgroundColor: colorPalette.white,
        border: "".concat(colorPalette.gray200, " solid 1px"),
        borderRadius: '8px',
        padding: '4px 7px',
        display: 'flex',
        width: 'fit-content',
    },
    imageWrapper: {
        cursor: 'pointer'
    },
    popoverAlert: {
        position: 'relative',
        '& > div': {
            position: 'fixed',
            zIndex: 1400
        },
    },
};

var EnergeticNote = function (_a) {
    var energeticNoteIcon = _a.energeticNoteIcon, energeticNoteImage = _a.energeticNoteImage;
    var _b = React.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    var open = Boolean(anchorEl);
    if (!energeticNoteIcon && !energeticNoteImage) {
        return null;
    }
    return (React.createElement(Box, { "data-qa": "energetic-test", component: "div", sx: energeticNoteStyles.indexWrapper },
        React.createElement(Box, { component: 'img', src: energeticNoteIcon, width: "40px", height: "36px", alt: "Note Energetique", onClick: handleClick, style: energeticNoteStyles.imageWrapper }),
        React.createElement(Popover, { id: "mouse-over-popover", sx: energeticNoteStyles.popoverAlert, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: 'center',
                horizontal: 'center',
            }, transformOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, className: "_hy", container: hypernovaClassWrapper }, energeticNoteImage && React.createElement(Box, { dangerouslySetInnerHTML: { __html: energeticNoteImage } }))));
};

var ImageLoader = forwardRef(function (_a, ref) {
    var src = _a.src, blurHash = _a.blurHash, aspectRatio = _a.aspectRatio, isImageLoaded = _a.isImageLoaded, setIsImageLoaded = _a.setIsImageLoaded, isMobile = _a.isMobile, onClick = _a.onClick, handleChange = _a.handleChange, withSideBanner = _a.withSideBanner, rest = __rest(_a, ["src", "blurHash", "aspectRatio", "isImageLoaded", "setIsImageLoaded", "isMobile", "onClick", "handleChange", "withSideBanner"]);
    var theme = useTheme();
    var _b = useState(false), hasError = _b[0], setHasError = _b[1];
    var _c = useState(532), width = _c[0], setWidth = _c[1];
    var handleImageLoad = function () {
        setIsImageLoaded(true);
        setHasError(false);
    };
    var handleImageError = function () {
        setIsImageLoaded(false);
        setHasError(true);
    };
    useEffect(function () {
        var updateWindowDimensions = function () {
            var newWidth = window.innerWidth;
            if (newWidth > 1920) {
                setWidth(532);
            }
            else if (newWidth <= 1920 && newWidth > 1536) {
                setWidth(472);
            }
            else if (newWidth <= 1536 && newWidth > 1440) {
                setWidth(400);
            }
            else {
                setWidth(270);
            }
        };
        window.addEventListener('resize', updateWindowDimensions);
        return function () { return window.removeEventListener('resize', updateWindowDimensions); };
    }, []);
    useEffect(function () {
        if (window) {
            var newWidth = window.innerWidth;
            if (newWidth > 1920) {
                setWidth(532);
            }
            else if (newWidth <= 1920 && newWidth > 1536) {
                setWidth(472);
            }
            else if (newWidth <= 1536 && newWidth > 1440) {
                setWidth(400);
            }
            else {
                setWidth(270);
            }
        }
    }, []);
    if (isMobile) {
        return (React.createElement(Box, { component: "div", className: "_hy", sx: {
                backgroundColor: 'white',
                width: '290px',
            } },
            !isImageLoaded && !hasError && blurHash && (React.createElement(Blurhash, { hash: blurHash, resolutionX: 32, resolutionY: 32, punch: 1, style: {
                    position: 'absolute',
                    width: '270px',
                    height: "".concat(270 / (aspectRatio || 1), "px"),
                    maxHeight: '270px',
                    display: isImageLoaded ? 'none' : 'block',
                    margin: '0 auto',
                } })),
            React.createElement(Box, { component: "div", className: "_hy", sx: {
                    '.slick-list': {
                        display: isImageLoaded ? 'block' : 'none',
                        width: '290px',
                        height: '290px',
                    },
                } },
                React.createElement(Slider, { arrows: false, draggable: true, dots: true, lazyLoad: "ondemand", beforeChange: handleChange }, src &&
                    Array.isArray(src) &&
                    src.map(function (img, i) {
                        var imgSrc = typeof img === 'string' ? img : img.url || '';
                        return (React.createElement(Box, { key: typeof img === 'string' ? img : img.url, sx: {
                                width: '290px !important',
                                height: '290px !important',
                                backgroundColor: 'white !important',
                            } },
                            React.createElement(Box, __assign({ component: "img", sx: __assign(__assign({}, mobileImageBoxStyle), { width: '290px', height: '290px' }), onError: handleImageError, onLoad: i === 0 ? handleImageLoad : undefined, loading: i !== 0 ? 'lazy' : 'eager', alt: "sliderImage", src: getSizeOptimizedImageUrl(imgSrc, 370), onClick: onClick }, rest))));
                    })))));
    }
    return (React.createElement(Box, { component: "div", sx: { position: 'relative' } },
        !isImageLoaded && !hasError && blurHash && (React.createElement(Box, { sx: __assign(__assign({}, imageBoxStyle(theme, withSideBanner)), { display: 'flex', justifyContent: 'center', alignItems: 'center' }) },
            React.createElement(Blurhash, { hash: blurHash, resolutionX: 32, resolutionY: 32, punch: 1, style: {
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: "".concat(width, "px"),
                    height: "".concat(width / (aspectRatio || 1), "px"),
                    maxHeight: width,
                    display: isImageLoaded ? 'none' : 'block',
                } }))),
        hasError && typeof src === 'undefined' && React.createElement(NoProductImage, null),
        React.createElement(Box, { sx: {
                visibility: isImageLoaded ? 'visible' : 'hidden',
                position: isImageLoaded ? 'relative' : 'absolute',
                opacity: isImageLoaded ? 1 : 0,
                transition: 'opacity 0.1s linear',
            } },
            React.createElement(Box, __assign({ component: "img", ref: ref, src: src, alt: "main thumbnail", loading: "lazy", onLoad: handleImageLoad, onError: handleImageError, onClick: onClick, sx: imageBoxStyle(theme, withSideBanner) }, rest)))));
});

var MobileImageGallery = function (_a) {
    var mobImageIndex = _a.mobImageIndex, onClose = _a.onClose, open = _a.open, urlsImage = _a.urlsImage;
    return (React.createElement(Drawer, { open: open, container: hypernovaClassWrapper, onClose: onClose, content: React.createElement(Stack, { sx: {
                padding: '72px 16px 16px 16px',
            } },
            React.createElement(Stack, null,
                React.createElement(Stack, { spacing: 2 },
                    React.createElement(Box, { component: "img", src: urlsImage && getSizeOptimizedImageUrl(urlsImage[mobImageIndex], 261), alt: "Mobile Image" }), urlsImage === null || urlsImage === void 0 ? void 0 :
                    urlsImage.filter(function (img) { return img != urlsImage[mobImageIndex]; }).map(function (src, i) { return (React.createElement(Box, { component: 'img', key: i, src: getSizeOptimizedImageUrl(src, 261), alt: "Mobile Image" })); })))), title: "Galerie d'images", PaperProps: {
            sx: {
                height: '100vh',
            },
        } }));
};

var carouselStyle = {
    flexDirection: 'column',
    width: 'auto',
    padding: '10px',
    position: 'relative',
    right: '0px',
    display: 'flex',
    '@media (max-width: 768px)': {
        width: '100%',
    },
};
var buttonStyle = {
    background: colorPalette.white,
    textAlign: 'center',
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    padding: '12px',
    boxShadow: "0px 2px 4px 0px #0000001A",
    cursor: 'pointer',
    position: 'absolute',
    left: '28%',
    zIndex: 1000,
    '@media (max-width: 768px)': {
        display: 'none',
    },
};
var prevButton = __assign(__assign({}, buttonStyle), { transform: 'translateY(-100%)', top: '5%' });
var nextButton = __assign(__assign({}, buttonStyle), { order: 1, top: '105%', transform: 'translateY(-100%)' });
var iconStyle = {
    width: '25px',
    height: '25px',
    color: colorPalette.gray700,
};
var nextIcon = {
    transform: 'rotate(180deg)',
};

var carouselStyles = {
    popupPreviewWrapper: function () { return ({
        cursor: 'pointer',
        width: '56px',
        height: '56px',
        borderRadius: '8px',
        justifyContent: 'center',
        alignItems: 'center',
    }); },
};
var itemStyle = {
    flexShrink: 0,
    flexGrow: 0,
    margin: 'auto',
    height: '72px',
    width: '72px',
    border: "1px solid ".concat(colorPalette.gray300),
    borderRadius: '8px',
    placeContent: 'center',
    display: 'grid',
    ':hover': {
        border: "1px solid ".concat(colorPalette.gray1000),
    },
};
var carouselContainer = {
    display: 'flex',
    flexFlow: 'column',
    overflow: 'auto',
    margin: '0 10px',
    height: '500px',
    scrollBehavior: 'smooth',
    gap: '8px',
    scrollbarWidth: 'none',
};
var carouselSmallContainer = {
    height: 'auto',
    '@media (max-width: 768px)': {
        paddingBlock: '10px',
    },
};

var Carousel = forwardRef(function (props, ref) {
    var _a;
    var sendEvent = useGTM().sendEvent;
    return (React.createElement(Stack, { component: "section", spacing: 1, sx: props.images.length < 5 ? carouselSmallContainer : carouselContainer, ref: ref, "data-qa": "carousel" }, (_a = props.images) === null || _a === void 0 ? void 0 : _a.map(function (src, item) { return (React.createElement(Box, { component: "div", key: item, "data-qa": "image-container", sx: itemStyle },
        React.createElement(Stack, { component: "img", src: getSizeOptimizedImageUrl(src, 48, 48), alt: "", "data-qa": "image", sx: carouselStyles.popupPreviewWrapper(item === props.hoveredImageIndex), onMouseEnter: function () {
                sendEvent({
                    event: 'FPA::diaporama_produit_defilement',
                    page_title: 'product image',
                    location_alias: 'product_image_carousel',
                });
                props.setHoveredImageIndex(item);
            } }))); })));
});

var Thumbnail = function (_a) {
    var urlsImage = _a.urlsImage, hoveredImageIndex = _a.hoveredImageIndex, setHoveredImageIndex = _a.setHoveredImageIndex;
    var _b = useState(false), showArrows = _b[0], setShowArrows = _b[1];
    var _c = useState(true), isPrevDisabled = _c[0], setIsPrevDisabled = _c[1];
    var _d = useState(false), isNextDisabled = _d[0], setIsNextDisabled = _d[1];
    var ref = useRef(null);
    var checkPrevDisabled = function () {
        if (ref.current) {
            setIsPrevDisabled(ref.current.scrollTop === 0);
        }
    };
    var checkNextDisabled = function () {
        if (ref.current) {
            var _a = ref.current, scrollTop = _a.scrollTop, scrollHeight = _a.scrollHeight, clientHeight = _a.clientHeight;
            setIsNextDisabled(scrollTop + clientHeight >= scrollHeight);
        }
    };
    useEffect(function () {
        var container = ref.current;
        if (container) {
            var handleScroll = function () {
                setShowArrows(container.scrollTop + container.clientHeight < container.scrollHeight);
            };
            setTimeout(handleScroll, 1000);
        }
    }, []);
    useEffect(function () {
        var container = ref.current;
        if (container) {
            container.addEventListener('scroll', checkPrevDisabled);
            container.addEventListener('scroll', checkNextDisabled);
            checkPrevDisabled();
            checkNextDisabled();
        }
        return function () {
            if (container) {
                container.removeEventListener('scroll', checkPrevDisabled);
                container.removeEventListener('scroll', checkNextDisabled);
            }
        };
    }, []);
    var prev = function () {
        var container = ref.current;
        if (container) {
            requestAnimationFrame(function () {
                var scrollTop = container.scrollTop;
                var itemHeight = parseInt(getComputedStyle(container.children[0]).height);
                container.scrollTop = scrollTop - itemHeight * 3;
            });
        }
    };
    var next = function () {
        var container = ref.current;
        if (container) {
            requestAnimationFrame(function () {
                var scrollTop = container.scrollTop;
                var itemHeight = parseInt(getComputedStyle(container.children[0]).height);
                container.scrollTop = scrollTop + itemHeight * 3;
            });
        }
    };
    return (React.createElement(Stack, null,
        React.createElement(Box, { sx: carouselStyle },
            showArrows && (React.createElement(Box, { sx: prevButton, onClick: prev, "data-qa": "prev-button", style: { backgroundColor: isPrevDisabled ? colorPalette.gray300 : colorPalette.white } },
                React.createElement(ExpandLess, { sx: iconStyle, style: { color: isPrevDisabled ? colorPalette.white : colorPalette.gray700 } }))),
            React.createElement(Carousel, { images: urlsImage, ref: ref, hoveredImageIndex: hoveredImageIndex, setHoveredImageIndex: setHoveredImageIndex }),
            showArrows && (React.createElement(Box, { sx: nextButton, onClick: next, "data-qa": "next-button", style: { backgroundColor: isNextDisabled ? colorPalette.gray300 : colorPalette.white } },
                React.createElement(ExpandLess, { sx: nextIcon, style: { color: isNextDisabled ? colorPalette.white : colorPalette.gray700 } }))))));
};

var _a, _b;
var galleryBoxWrapper = {
    display: 'flex',
    height: '100%',
    width: '100%',
    padding: '8px 16px 16px 16px',
};
var galleryBoxContainer = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
};
var controlContainer = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: 32,
};
var closeButtonDesk = {
    position: 'absolute',
    top: 10,
    right: 10,
    backgroundColor: colorPalette.gray100,
    width: 48,
    height: 48,
    borderRadius: 99,
};
({
    width: 48,
    height: 48,
    borderRadius: 99,
    display: 'flex',
    backgroundColor: colorPalette.gray100,
    justifyContent: 'center',
    alignItems: 'center',
    cursor: 'pointer',
});
var emptyContainer = {
    display: 'flex',
    flex: 1,
};
__assign(__assign({}, emptyContainer), { justifyContent: 'center' });
__assign(__assign({}, emptyContainer), { justifyContent: 'flex-end' });
({
    backgroundColor: colorPalette.gray100,
    width: 48,
    height: 48,
    borderRadius: 99,
});
var imageStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    objectPosition: 'center',
};
var flexWrapper = {
    display: 'flex',
};
var modalContainer = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
};
var wrapper = __assign(__assign({}, flexWrapper), { width: '100%', height: '100%', margin: '0px 64px', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' });
var sponsoWrapper = (_a = {
        position: 'absolute',
        width: '300px',
        height: '250px',
        right: '15px',
        bottom: '15px',
        backgroundColor: 'red'
    },
    _a['@media (max-width: 1440px)'] = {
        width: '18%',
        height: '24%',
    },
    _a['@media (max-width: 1200px)'] = {
        width: '12%',
        height: '16%',
    },
    _a);
var imageWrapper = (_b = {
        maxWidth: '1002px',
        maxHeight: '100vh',
        marginTop: '48px',
        marginBottom: '48px',
        display: 'flex',
        flex: 1
    },
    _b['@media (max-width: 1440px)'] = {
        maxWidth: '823px',
        maxHeight: '823px',
        marginTop: '48px',
        marginBottom: '48px',
    },
    _b['@media (max-width: 1200px)'] = {
        maxWidth: '642px',
        maxHeight: '642px',
        marginTop: '48px',
        marginBottom: '48px',
    },
    _b);

var DesktopImageGallery = function (_a) {
    var open = _a.open, imageIndex = _a.imageIndex, urlsImage = _a.urlsImage, onClose = _a.onClose, setHoveredImageIndex = _a.setHoveredImageIndex;
    return (React.createElement(Modal, { sx: modalContainer, open: open, onClose: onClose, slotProps: { backdrop: { sx: { backgroundColor: 'white' } } }, container: hypernovaClassWrapper },
        React.createElement(React.Fragment, null,
            React.createElement(Stack, { sx: galleryBoxWrapper },
                React.createElement(Stack, { sx: galleryBoxContainer },
                    React.createElement(Stack, { sx: controlContainer }, urlsImage && urlsImage.length > 1 && (React.createElement(Thumbnail, { urlsImage: urlsImage, hoveredImageIndex: imageIndex, setHoveredImageIndex: setHoveredImageIndex }))),
                    React.createElement(Stack, { sx: wrapper },
                        React.createElement(Stack, { sx: imageWrapper },
                            React.createElement(Box, { component: 'img', sx: imageStyle, src: urlsImage && getSizeOptimizedImageUrl(urlsImage[imageIndex], 532), alt: "Full Screen Image" }))),
                    React.createElement(Stack, { sx: flexWrapper },
                        React.createElement(IconButton, { sx: closeButtonDesk, onClick: onClose },
                            React.createElement(CloseIcon, null)),
                        React.createElement(Stack, { sx: sponsoWrapper, id: "crt2-1263263" })))))));
};

var ImageGalleryContainer = function (_a) {
    var imageIndex = _a.imageIndex, mobImageIndex = _a.mobImageIndex, onClose = _a.onClose, open = _a.open, urlsImage = _a.urlsImage, setHoveredImageIndex = _a.setHoveredImageIndex;
    var breakpoint = useBreakpoint().breakpoint;
    useEffect(function () {
        var handleKeyDown = function (event) {
            if (event.key === 'Escape') {
                onClose();
            }
        };
        if (open) {
            document.addEventListener('keydown', handleKeyDown);
        }
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [onClose, open]);
    if (breakpoint === 'phone') {
        return React.createElement(MobileImageGallery, { mobImageIndex: mobImageIndex, open: open, urlsImage: urlsImage, onClose: onClose });
    }
    return (React.createElement(DesktopImageGallery, { open: open, imageIndex: imageIndex, onClose: onClose, urlsImage: urlsImage, setHoveredImageIndex: setHoveredImageIndex }));
};

var Image = function (_a) {
    var _b;
    var _c;
    var urlsImage = _a.urlsImage, productId = _a.productId, _d = _a.dataQa, dataQa = _d === void 0 ? 'images-core' : _d, hasRichContentVideo = _a.hasRichContentVideo, blurredMemoUpdateActionUrl = _a.blurredMemoUpdateActionUrl, urlProductAlert = _a.urlProductAlert, onNotificationClick = _a.onNotificationClick, repairabilityIndexImageUrl = _a.repairabilityIndexImageUrl, repairabilityIndexPdfUrl = _a.repairabilityIndexPdfUrl, galleryData = _a.galleryData, galleryIdResponse = _a.galleryIdResponse;
    var theme = useTheme$1();
    var dispatch = useDispatch();
    var sendEvent = useGTM().sendEvent;
    var breakpoint = useBreakpoint().breakpoint;
    var _e = useState(false), isOpenGallery = _e[0], setIsOpenGallery = _e[1];
    var _f = useState(0), hoveredImageIndex = _f[0], setHoveredImageIndex = _f[1];
    var _g = useState(0), mobHoveredImageIndex = _g[0], setMobHoveredImageIndex = _g[1];
    var _h = useState(''), energeticNoteIcon = _h[0], setEnergeticNoteIcon = _h[1];
    var _j = useState(''), energeticNoteImage = _j[0], setEnergeticNoteImage = _j[1];
    var _k = useState(false), isSideBannerPresent = _k[0], setIsSideBannerPresent = _k[1];
    useEffect(function () {
        var sideBannerElement = document.querySelector('.kml-sideBanner, .sideBanner');
        if (sideBannerElement) {
            setIsSideBannerPresent(true);
        }
        else {
            setIsSideBannerPresent(false);
        }
    }, []);
    var noteRef = useRef(false);
    var imageUrls = ((_c = galleryData === null || galleryData === void 0 ? void 0 : galleryData.images) === null || _c === void 0 ? void 0 : _c.map(function (image) { return ({
        url: image.publicImageUrl,
        blurHash: image.blurHash,
        aspectRatio: image.aspectRatio || 1,
        rank: image.rank,
    }); }).filter(function (image) { return typeof image.url !== 'undefined' && typeof image.rank !== 'undefined'; }).sort(function (a, b) { return a.rank - b.rank; })) || urlsImage;
    var userData = useSelector(function (state) { return state.productImage && state.productImage.userData; });
    var productAdditionalData = useSelector(function (state) { return state.productImage && state.productImage.productAdditionalData; });
    var onVideoClick = function () {
        var targetSection = document.getElementById('ancre_rich_ctn');
        if (targetSection) {
            targetSection.scrollIntoView({ behavior: 'smooth' });
        }
    };
    var imgContainerRef = useRef(null);
    var imgRef = useRef(null);
    var lensRef = useRef(null);
    var outputRef = useRef(null);
    var overviewRef = useRef(null);
    var wrapperRef = useRef(null);
    var _l = useState(false), snackbarVisible = _l[0], setSnackbarVisible = _l[1];
    var _m = useState(false), refsReady = _m[0], setRefsReady = _m[1];
    var _o = useState(0), width = _o[0], setWidth = _o[1];
    var _p = useState(false), isImageLoaded = _p[0], setIsImageLoaded = _p[1];
    useEffect(function () {
        if ((galleryIdResponse === null || galleryIdResponse === void 0 ? void 0 : galleryIdResponse.summaryAttributeValue) && !noteRef.current) {
            getNoteEnergetic(galleryIdResponse.summaryAttributeValue, setEnergeticNoteIcon, setEnergeticNoteImage);
            noteRef.current = true;
        }
    }, [galleryIdResponse]);
    useEffect(function () {
        var _a, _b;
        dispatch(getFavoriteState(((_a = galleryIdResponse === null || galleryIdResponse === void 0 ? void 0 : galleryIdResponse.productId) === null || _a === void 0 ? void 0 : _a.toString()) || productId || '', ((_b = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _b === void 0 ? void 0 : _b.userId) || 0));
    }, [galleryIdResponse, productId, userData]);
    useEffect(function () {
        if (overviewRef.current || outputRef.current) {
            setRefsReady(true);
        }
    }, [overviewRef.current, outputRef.current]);
    useEffect(function () {
        var img = imgRef.current;
        var imgContainer = imgContainerRef.current;
        var output = outputRef.current;
        var lens = lensRef.current;
        var overview = overviewRef.current;
        if (!output || !lens || !overview || !imgContainer || !img || !isImageLoaded) {
            return;
        }
        lens.style.display = 'none';
        output.style.display = 'none';
        var commandFunc = function (e) {
            output.style.display = 'initial';
            overview.style.display = 'initial';
            lens.style.display = 'block';
            var rect = imgContainer.getBoundingClientRect();
            var x = e.clientX - rect.left;
            var y = e.clientY - rect.top;
            x = x - lens.offsetWidth / 2;
            y = y - lens.offsetHeight / 2;
            x = Math.max(0, Math.min(x, rect.width - lens.offsetWidth));
            y = Math.max(0, Math.min(y, rect.width - lens.offsetHeight));
            var xAxis = (rect.width - img.offsetWidth) / 2;
            lens.style.top = "".concat(y + Math.trunc(Math.abs((rect.height - img.height) / 2)), "px");
            lens.style.left = "".concat(x - xAxis, "px");
            overview.style.left = "".concat(rect.right + 20, "px");
            overview.style.top = "".concat(rect.top + window.scrollY, "px");
            var scaleX = output.width / lens.offsetWidth;
            var scaleY = output.height / lens.offsetHeight;
            var zoom = 2.8;
            if (width >= 1920) {
                zoom = 2.8;
            }
            else if (width >= 1536 && width < 1920) {
                zoom = 2.5;
            }
            else if (width >= 1440 && width < 1536) {
                zoom = 2.2;
            }
            else if (width < 1440) {
                zoom = 2;
            }
            output.style.transform = "translate(".concat(-x * scaleX, "px, ").concat(-y * scaleY, "px) scale(").concat(zoom, ", ").concat(zoom, ")");
            output.style.transformOrigin = 'top left';
        };
        var showSnackbar = function () {
            setSnackbarVisible(true);
        };
        var hideZoomImage = function () {
            output.style.display = 'none';
            lens.style.display = 'none';
            overview.style.display = 'none';
            setSnackbarVisible(false);
        };
        imgContainer.addEventListener('mousemove', commandFunc);
        imgContainer.addEventListener('mouseover', showSnackbar);
        imgContainer.addEventListener('mouseout', hideZoomImage);
        return function () {
            imgContainer.addEventListener('mousemove', commandFunc);
            imgContainer.addEventListener('mouseover', showSnackbar);
            imgContainer.addEventListener('mouseout', hideZoomImage);
        };
    }, [lensRef, refsReady, breakpoint, imgContainerRef, width, isImageLoaded]);
    useEffect(function () {
        if (!window)
            return;
        if (window) {
            var newWidth = window.innerWidth;
            setWidth(newWidth);
        }
    }, []);
    useEffect(function () {
        var updateWindowDimensions = function () {
            if (window) {
                var newWidth = window.innerWidth;
                setWidth(newWidth);
            }
        };
        if (!window)
            return;
        window === null || window === void 0 ? void 0 : window.addEventListener('resize', updateWindowDimensions);
        return function () { return window === null || window === void 0 ? void 0 : window.removeEventListener('resize', updateWindowDimensions); };
    }, []);
    useEffect(function () {
        var wrapper = wrapperRef.current;
        if (wrapper) {
            var parent_1 = wrapper.parentElement;
            if (!parent_1) {
                return;
            }
            var hasSideBar = document.querySelector('.sideBanner') !== null;
            if ((hasSideBar && width > 1536) || (!hasSideBar && width > 1440)) {
                parent_1.style.width = '41%';
            }
            else {
                parent_1.style.width = '345px';
            }
        }
    }, [width]);
    var handleSnackbarMouseEnter = function () {
        setSnackbarVisible(true);
    };
    var handleSnackbarMouseLeave = function () {
        setSnackbarVisible(false);
    };
    var onFavoriteClick = function () {
        dispatch(handleMemoClick((productAdditionalData === null || productAdditionalData === void 0 ? void 0 : productAdditionalData.isFavorite) || false, blurredMemoUpdateActionUrl || ''));
    };
    var openModal = function (isOpen) {
        var overview = overviewRef.current;
        sendEvent({
            event: 'FPA::diaporama_produit_ouverture',
            page_title: 'product image',
            location_alias: 'product_image_open',
        });
        if (overview && overview.style.display !== 'none') {
            overview.style.display = 'none';
        }
        setIsOpenGallery(isOpen);
    };
    var closeModal = function () {
        setIsOpenGallery(false);
    };
    var handleChange = function (oldIndex, newIndex) {
        setHoveredImageIndex(newIndex);
        setMobHoveredImageIndex(newIndex);
    };
    var handleAspectRatio = function (image) {
        var _a;
        if (typeof image === 'object' && image !== null && 'aspectRatio' in image) {
            return (_a = image.aspectRatio) !== null && _a !== void 0 ? _a : 1;
        }
        return 1;
    };
    return (React.createElement(Stack, { component: "div", ref: wrapperRef, "data-qa": dataQa, sx: ProductImageWrapper(theme, isSideBannerPresent) },
        React.createElement(Stack, { direction: "row", position: "relative" },
            imageUrls && imageUrls.length > 0 && breakpoint !== 'phone' && (React.createElement(Preview, { images: imageUrls || [], onVideoClick: onVideoClick, video: hasRichContentVideo, onImageClick: function () { return openModal(true); }, hoveredImageIndex: hoveredImageIndex, setHoveredImageIndex: setHoveredImageIndex })),
            breakpoint === 'phone' ? (React.createElement(Stack, { sx: mobileImageBoxStyle, justifyContent: "center" },
                React.createElement(ImageLoader, { isMobile: true, ref: imgRef, isImageLoaded: isImageLoaded, setIsImageLoaded: setIsImageLoaded, src: imageUrls, blurHash: handleImageSource(imageUrls, mobHoveredImageIndex, 375, true), aspectRatio: imageUrls ? handleAspectRatio(imageUrls[mobHoveredImageIndex]) : undefined, onClick: function () { return openModal(true); }, handleChange: handleChange }),
                React.createElement(Stack, { spacing: 1, sx: {
                        position: 'absolute',
                        top: 0,
                        right: -5,
                        alignItems: 'center',
                    } },
                    React.createElement(Favorite, { isFavorite: productAdditionalData === null || productAdditionalData === void 0 ? void 0 : productAdditionalData.isFavorite, onFavoriteClick: onFavoriteClick }),
                    repairabilityIndexImageUrl && React.createElement(RepairabilityIndex, { imageUrl: repairabilityIndexImageUrl, pdfUrl: repairabilityIndexPdfUrl }),
                    energeticNoteIcon && React.createElement(EnergeticNote, { energeticNoteIcon: energeticNoteIcon, energeticNoteImage: energeticNoteImage })))) : (React.createElement(React.Fragment, null,
                React.createElement(Stack, { component: "div", ref: imgContainerRef, sx: imageBoxWrapperStyle, direction: "row", position: "relative" },
                    React.createElement(Stack, { sx: imageContainerDimStyle(theme, isSideBannerPresent) }, imageUrls && imageUrls.length === 0 ? (React.createElement(Box, { sx: {
                            height: '100%',
                            width: '100%',
                        } },
                        React.createElement(NoProductImage, null))) : (React.createElement(Box, { component: 'div', sx: { position: 'relative' } },
                        React.createElement(Stack, { "data-qa": "product-image", component: "div" },
                            React.createElement(ImageLoader, { ref: imgRef, isImageLoaded: isImageLoaded, setIsImageLoaded: setIsImageLoaded, src: handleImageSource(imageUrls, hoveredImageIndex, 532), blurHash: handleImageSource(imageUrls, hoveredImageIndex, 532, true), aspectRatio: imageUrls ? handleAspectRatio(imageUrls[hoveredImageIndex]) : undefined, withSideBanner: isSideBannerPresent, onClick: function () { return openModal(true); } }),
                            React.createElement(Box, { sx: zoomSquareStyle(theme), "data-qa": "zoom-square", ref: lensRef }),
                            React.createElement(Snackbar, { open: snackbarVisible, TransitionComponent: Fade, onClick: function () {
                                    openModal(true);
                                    setSnackbarVisible(false);
                                }, message: "Cliquer pour agrandir", onMouseEnter: handleSnackbarMouseEnter, onMouseLeave: handleSnackbarMouseLeave, sx: (_b = {
                                        position: 'absolute',
                                        cursor: 'pointer'
                                    },
                                    _b['& > div'] = {
                                        minWidth: '170px',
                                    },
                                    _b) })),
                        React.createElement(Portal, { container: hypernovaClassWrapper },
                            React.createElement(Box, { component: 'div', sx: __assign(__assign({}, zoomOverViewStyle), { display: 'none' }), "data-qa": "zoom-overview", ref: overviewRef },
                                React.createElement(Box, { component: 'img', ref: outputRef, src: handleImageSource(imageUrls, hoveredImageIndex, 1600), style: {
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'contain',
                                    } })))))),
                    React.createElement(Stack, { sx: imageIconsWrapperStyle },
                        React.createElement(Favorite, { isFavorite: productAdditionalData === null || productAdditionalData === void 0 ? void 0 : productAdditionalData.isFavorite, onFavoriteClick: onFavoriteClick }),
                        React.createElement(Link, { href: urlProductAlert },
                            React.createElement(Notification, { isNotificationOn: productAdditionalData === null || productAdditionalData === void 0 ? void 0 : productAdditionalData.hasPriceAlert, onNotificationClick: onNotificationClick })),
                        repairabilityIndexImageUrl && (React.createElement(RepairabilityIndex, { imageUrl: repairabilityIndexImageUrl, pdfUrl: repairabilityIndexPdfUrl })),
                        energeticNoteIcon && React.createElement(EnergeticNote, { energeticNoteIcon: energeticNoteIcon, energeticNoteImage: energeticNoteImage }))))),
            React.createElement(ImageGalleryContainer, { open: isOpenGallery, imageIndex: hoveredImageIndex, mobImageIndex: mobHoveredImageIndex, urlsImage: imageUrls === null || imageUrls === void 0 ? void 0 : imageUrls.map(function (img) { return (typeof img === 'string' ? img : img.url); }), onClose: closeModal, setHoveredImageIndex: setHoveredImageIndex }))));
};

var GET_USERID_QUERY = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["query productImage {\n  profile {\n    userId\n  }\n}\n"], ["query productImage {\n  profile {\n    userId\n  }\n}\n"])));
var templateObject_1;

var mapStateToProps = function (state) {
    var productImage = state.productImage;
    return __assign({}, productImage);
};
var mapDispatchToProps = function (
// TODO: dispatch action type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
dispatch) { return ({
    initialAction: function (context, baseUrl, preloadedConfig) {
        dispatch(initialAction(context, baseUrl, preloadedConfig));
    },
}); };
var ConnectedProductImage = connect(mapStateToProps, mapDispatchToProps)(Image);
var BreakpointWrappedProductImage = function () {
    var dispatch = useDispatch();
    var initialQuery = useQuery(GET_USERID_QUERY);
    if (initialQuery && !initialQuery.loading) {
        dispatch({ type: ACTIONS$1.FETCH_USER_DATA_SUCCESS, payload: initialQuery.data });
    }
    return (React.createElement(BreakpointProvider, null,
        React.createElement(ConnectedProductImage, null)));
};
var ProductImageContainer = BreakpointWrappedProductImage;

var NAME = 'productImage';
var DEFAULT_STATE = {};
var EnergeticNoteImageDummy = "\n<!DOCTYPE html>\n<html lang='fr-FR'>\n\n<head>\n\t<meta http-equiv='Content-Type' content='text/html; charset=UTF-8' />\n\t<meta name='viewport' content='width=device-width, initial-scale=1.0, maximum-scale=1.0'>\n\t<style type='text/css'>\n\t\tbody {\n\t\t\tbackground: transparent;\n\t\t\tmargin: 0px;\n\t\t\tpadding: 0px;\n\t\t}\n\t</style>\n\t<!-- ### PAGE HEAD BEGIN ### -->\n\t<script type='text/javascript'>\n\t\twindow[\"ccs_cc_initParams\"] = [\"732217ea\", \"ws.cs.1worldsync.com\"];\n\t</script>\n\t<!-- ### PAGE HEAD END ### -->\n</head>\n\n<body>\n\t<!-- ### PAGE CONTENT BEGIN ### -->\n\t<div id=\"logoTemplateEntry-205035\">\n\t\t<div class=\"ccs-euenergy-eco ccs-euenergy-eu ccs-euenergy-monitors\"\n\t\t\tstyle=\"padding:9px;width:262px;height:542px;\">\n\t\t\t<div class=\"ccs-euenergy-header\">\n\t\t\t\t<div class=\"ccs-euenergy-header-row\">\n\t\t\t\t\t<div class=\"ccs-euenergy-flag\"></div>\n\t\t\t\t\t<div class=\"ccs-euenergy-energy\"></div>\n\t\t\t\t\t<div class=\"ccs-euenergy-qr\"><svg version=\"1.1\" baseProfile=\"full\" shape-rendering=\"crispEdges\"\n\t\t\t\t\t\t\twidth=\"49\" height=\"49\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t\t\t\t<rect x=\"0\" y=\"0\" width=\"49\" height=\"49\" fill=\"#FFFFFF\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"4\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"5\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"6\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"7\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"8\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"9\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"10\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"11\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"12\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"13\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"14\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"15\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"16\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"17\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"18\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"19\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"20\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"21\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"22\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"23\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"24\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"25\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"26\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"27\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"28\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"29\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"30\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"31\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"32\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"33\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"34\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"11\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"35\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"36\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"37\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"38\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"39\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"17\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"39\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"40\" y=\"44\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"19\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"26\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"29\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"31\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"40\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"41\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"12\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"22\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"42\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"13\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"18\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"20\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"27\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"28\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"30\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"32\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"33\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"38\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"42\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"43\" y=\"43\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"4\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"5\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"6\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"7\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"8\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"9\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"10\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"14\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"15\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"16\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"21\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"23\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"24\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"25\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"34\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"35\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"36\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"37\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t\t<rect x=\"44\" y=\"41\" width=\"1\" height=\"1\" fill=\"#000000\" />\n\t\t\t\t\t\t</svg></div>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ccs-euenergy-header-row\">\n\t\t\t\t\t<div class=\"ccs-euenergy-mfr\">Samsung</div>\n\t\t\t\t\t<div class=\"ccs-euenergy-pn\">TQ55LS03BGU</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<div class=\"ccs-euenergy-charts\">\n\n\n\t\t\t\t<div class=\"ccs-euenergy-chart \" data-grades-number=\"7\">\n\t\t\t\t\t<div class=\"ccs-euenergy-grade\">\n\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class\">\n\t\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class-inner\">\n\t\t\t\t\t\t\t\tA\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"ccs-euenergy-grade\">\n\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class\">\n\t\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class-inner\">\n\t\t\t\t\t\t\t\tB\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"ccs-euenergy-grade\">\n\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class\">\n\t\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class-inner\">\n\t\t\t\t\t\t\t\tC\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"ccs-euenergy-grade\">\n\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class\">\n\t\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class-inner\">\n\t\t\t\t\t\t\t\tD\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"ccs-euenergy-grade\">\n\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class\">\n\t\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class-inner\">\n\t\t\t\t\t\t\t\tE\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"ccs-euenergy-grade\">\n\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class\">\n\t\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class-inner\">\n\t\t\t\t\t\t\t\tF\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div class=\"ccs-euenergy-grade\">\n\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class\">\n\t\t\t\t\t\t\t<div class=\"ccs-euenergy-grade-class-inner\">\n\t\t\t\t\t\t\t\tG\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"ccs-euenergy-indicator\">\n\t\t\t\t\t\t\t<div class=\"ccs-euenergy-indicator-inner\" aria-label=\"g Rating\">\n\t\t\t\t\t\t\t\tg\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t</div>\n\n\t\t\t<div class=\"ccs-euenery-consumption\">\n\t\t\t\t<div class=\"ccs-euenergy-value\" tabindex=\"0\" aria-label=\"Energy Consumption 84 kWh/1000h\">\n\t\t\t\t\t84 <span class=\"ccs-euenergy-unit\">kWh/1000h</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\n\n\t\t\t<div class=\"ccs-euenergy-attributes\">\n\t\t\t\t<div class=\"ccs-euenergy-classes\" tabindex=\"0\" aria-label=\"Energy Class  G\">\n\t\t\t\t\tABCDEF<span class=\"ccs-euenergy-bold\">G</span>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ccs-euenergy-hdr\"></div>\n\t\t\t\t<div class=\"ccs-euenergy-power\" tabindex=\"0\" aria-label=\"Energy Power 181 kWh/1000h\">\n\t\t\t\t\t181 <span class=\"ccs-euenergy-unit\">kWh/1000h</span>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"ccs-euenergy-monitor\" tabindex=\"0\"\n\t\t\t\t\taria-label=\"Horizontal Rresolution 3840 px Vertical Resolution 2160 px Diagonal \u0421entimeter 138 cm Diagonal Inch 55 inch\">\n\t\t\t\t\t<div class=\"ccs-horizontal-resolution\">3840 px</div>\n\t\t\t\t\t<div class=\"ccs-vertical-resolution\">2160 px</div>\n\t\t\t\t\t<div class=\"ccs-diagonal-cm\">138 cm</div>\n\t\t\t\t\t<div class=\"ccs-diagonal-inch\">55 \"</div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div class=\"ccs-euenergy-regulation-numbering\">\n\t\t\t\t2019/2013\n\t\t\t</div>\n\n\t\t</div>\n\t</div>\n\n\t<link href='https://cdn.cs.1worldsync.com/static/pe/220620-OORC/Logo/Templates/EuEnergyEco/EuEnergy.css'\n\t\trel='stylesheet' type='text/css' />\n\t<link\n\t\thref='https://cdn.cs.1worldsync.com/redirect/gp-subscriber-files/732217ea/e1d6742941/Style.Minified/20220411132906.css'\n\t\trel='stylesheet' type='text/css' />\n\t<script type='text/javascript' src='https://cdn.cs.1worldsync.com/jsc/cl1ws.js'></script>\n\t<script type='text/javascript'\n\t\tsrc='https://cdn.cs.1worldsync.com/static/pe/220620-OORC/jquery/jquery-3.5.1.modified.min.js'></script>\n\t<script type='text/javascript' src='https://cdn.cs.1worldsync.com/static/pe/220620-OORC/Logo/LogoProgram.min.js'>\n\t</script>\n\t<script type='text/javascript'\n\t\tsrc='https://cdn.cs.1worldsync.com/static/pe/220620-OORC/Logo/Templates/EuEnergyEco/EuEnergy.min.js'></script>\n\t<script type='text/javascript'>\n\t\tccs_require('logoProgram');if (window.postMessage) window.parent.postMessage('{\"hoverLoad\":\"\"}', \"*\");window.CcsLogoProgram.detectFeatures('logoTemplateEntry-205035');;ccs_require('logoProgram');ccs_require('euenergy').init('logoTemplateEntry-205035');\nccs_cc_loge_c04458('bb1ac6f9');\nfunction ccs_cc_gete_params_c04458(id){switch(id){\ncase 'bb1ac6f9': return { et: 'ProductHookLoad', serverParams: {\"ElementIds\":\"logo-euenergy\",\"ServerTime\":\"86\",\"ResultCode\":\"0\"} };break;\n}}\nfunction ccs_cc_loge_c04458(id, clientParams){\nvar eventInfo = ccs_cc_gete_params_c04458(id); if(!eventInfo) return;\nccs_cc_log.logEvent (eventInfo.et, 'SKey=732217ea&LCID=1036&Market=FR&Locale=FR-FRA&ZoneId=e1d6742941&ZoneVer=26&MfgPn=TQ55LS03BGUXXC&MasterId=106428310c7d000d&SMfgName=Samsung&SMfgPn=TQ55LS03BGUXXC&MfgId=69', eventInfo.serverParams, clientParams); }\n\n\nif (typeof ccs_cc_ready != \"undefined\" && ccs_cc_ready != null) ccs_cc_ready();\n\t</script>\n\t<!-- ### PAGE CONTENT END ### -->\n</body>\n\n</html>\n";

var constants = /*#__PURE__*/Object.freeze({
  __proto__: null,
  NAME: NAME,
  DEFAULT_STATE: DEFAULT_STATE,
  EnergeticNoteImageDummy: EnergeticNoteImageDummy
});

var initialState = {
    productId: '',
    userId: '',
    urlsImage: [],
    hasRichContentVideo: false,
    isFavorite: false,
    userData: null,
};
function reducer(state, action) {
    var _a, _b;
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ACTIONS$1.FETCH_GALLERY_DATA:
            return __assign(__assign({}, state), { galleryData: (_a = action.payload) === null || _a === void 0 ? void 0 : _a.galleryData });
        case ACTIONS$1.FETCH_GET_GALLERY_ID:
            return __assign(__assign({}, state), { galleryIdResponse: (_b = action.payload) === null || _b === void 0 ? void 0 : _b.galleryIdResponse });
        case ACTIONS$1.FETCH_PRODUCT_IMAGE_DATA_SUCCESS:
            return __assign(__assign({}, state), action.payload);
        case ACTIONS$1.FETCH_PRODUCT_IMAGE_DATA_ERROR:
            return __assign(__assign({}, state), { customStatusCode: action.payload.statusCode });
        case ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_REQUEST:
            return __assign(__assign({}, state), { productAdditionalData: null });
        case ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_SUCCESS:
            return __assign(__assign({}, state), { productAdditionalData: action.payload });
        case ACTIONS$1.FETCH_IS_PRODUCT_FAVORITE_ERROR:
            return __assign(__assign({}, state), { productAdditionalData: null });
        case ACTIONS$1.PRODUCT_FAVORITE_UPDATE_REQUEST:
            return __assign({}, state);
        case ACTIONS$1.PRODUCT_FAVORITE_UPDATE_SUCCESS:
            return __assign(__assign({}, state), { productAdditionalData: __assign(__assign({}, state.productAdditionalData), { isFavorite: action.payload }) });
        case ACTIONS$1.PRODUCT_FAVORITE_UPDATE_ERROR:
            return __assign({}, state);
        case ACTIONS$1.FETCH_IS_PRODUCT_REPAIRABILITY_INDEX_SUCCESS:
            return __assign(__assign({}, state), { repairabilityIndexImageUrl: action.payload.repairabilityIndexImageUrl, repairabilityIndexPdfUrl: action.payload.repairabilityIndexPdfUrl });
        case ACTIONS$1.FETCH_IS_PRODUCT_NOTE_ENERGETIC_SUCCESS:
            return __assign(__assign({}, state), { energeticNoteIcon: action.payload.energeticNoteIcon, energeticNoteImage: action.payload.energeticNoteImage });
        case ACTIONS$1.FETCH_USER_DATA_SUCCESS:
            return __assign(__assign({}, state), { userData: action.payload });
        default:
            return state;
    }
}

var containers = { ProductImageContainer: ProductImageContainer };
var productImageModule = { containers: containers, actions: actions, constants: constants, reducer: reducer, initalAction: initialAction };

export { productImageModule as default };
